// @flow
import * as React from 'react';
import styled from 'styled-components';
import colors from '../../assets/css/colors';
import ArrowDown from '../Icons/ArrowDown';

const TeamSelectWrapper = styled.div`
	display: flex;
	position: relative;
	width: auto;
	height: 38px;
	align-items: center;
	margin-right: 10px;
	.arrow {
		margin-left: 5px;
		pointer-events: none;
		color: ${colors.nrlDarkGreen};
		position: absolute;
		right: 0;
	}
`;
const TeamSelectStyled = styled.select`
	-webkit-appearance: none;
	-moz-appearance: none;
	outline: none;
	border-radius: 0;
	font-size: 14px;
	font-weight: bold;
	line-height: 1.5;
	border: none;
	max-width: 205px;
	background: transparent;
	color: ${colors.nrlDarkGreen};
	padding-right: 20px;
	&::-ms-expand {
	    display: none;
	}
`;
type Props = {
	children: React.Node,
	value: number,
	handleTeamSelect?: Function
}
export const TeamSelect = ({ children, handleTeamSelect, value }: Props) => (
	<TeamSelectWrapper>
		<TeamSelectStyled onChange={handleTeamSelect} value={value}>
			{children}
		</TeamSelectStyled>
		<ArrowDown className="arrow" />
	</TeamSelectWrapper>
);

export default TeamSelect;


// WEBPACK FOOTER //
// ./src/components/Team/TeamSelect.js